import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    button: {
      textTransform: 'capitalize !important',
    },
    cardContainer: {
      maxHeight: 838,
      overflowY: 'auto',
      marginTop: -theme.spacing(3),
      marginLeft: -theme.spacing(2),
      marginRight: -theme.spacing(2),
    },
    cardContentPadding: {
      padding: '24px;',
    },
    cardTitleContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    cardTitle: {
      fontWeight: 700,
      fontSize: 13,
    },
    cardStatus: {
      marginRight: 20,
      fontSize: 12,
    },
    logTimelineIcon: {
      maxWidth: '100%',
    },
    loadingContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: 100,
    },
    timeline: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      height: '100%',
      left: 0,
      position: 'absolute',
      top: 4,
      width: 20,
    },
    lastItem: {
      height: 'auto',
    },
    passedIcon: {
      fontSize: theme.typography.pxToRem(17),
    },
    circle: {
      borderRadius: '100%',
      border: '1px solid #8E8E93',
      minHeight: 14,
      minWidth: 14,
    },
    inProgress: {
      borderColor: '#FFB027',
    },
    failed: {
      borderColor: theme.palette.error.main,
    },
    bypassed: {
      borderColor: '#FFB027',
    },
    line: {
      backgroundColor: '#fff',
      border: 'none',
      borderLeft: `1px solid #CBCBCB`,
      color: '#fff',
      height: 'calc(100% - 3px)',
      margin: 0,
      width: 1,
    },
    linkBox: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      alignItems: 'center',
      display: 'flex',
      fontWeight: 'bold',
      margin: '5px 0',
    },
    invoiceIcon: {
      fontSize: 16,
      marginRight: 5,
    },
    barCompleted: {
      borderRadius: 4,
      backgroundColor: '#EEEEEE',
      '& .MuiLinearProgress-bar': {
        borderRadius: 4,
        backgroundColor: theme.palette.success.main,
      },
    },
    barInProgress: {
      borderRadius: 4,
      backgroundColor: '#EEEEEE',
      '& .MuiLinearProgress-bar': {
        borderRadius: 4,
        backgroundColor: '#FFB027',
      },
    },
    barFailed: {
      borderRadius: 4,
      backgroundColor: '#EEEEEE',
      '& .MuiLinearProgress-bar': {
        borderRadius: 4,
        backgroundColor: theme.palette.error.main,
      },
    },
    barNotStarted: {
      borderRadius: 4,
      backgroundColor: '#EEEEEE',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 0,
    marginBottom: 0,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

const customCardStyles = makeStyles(() => {
  return {
    root: {
      padding: '15px',
      paddingTop: '24px',
    },
  };
});

export { useStyles, customCardStyles, collapseCardStyles };
